import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InViewModule } from '@teamfoster/sdk/in-view';
import { Image, ImageModule } from '@teamfoster/sdk/image';
import { TextShapeComponent } from '../text-shape/text-shape.component';

@Component({
  selector: 'app-team-card',
  standalone: true,
  imports: [CommonModule, InViewModule, ImageModule, TextShapeComponent],
  templateUrl: './team-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamCardComponent {
  @Input() title!: string;
  @Input() image!: Image;
  @Input() active = false;
  @Input() showBackground = false;

  inview($e: any) {
    // this.moduleInview = $e;
  }
}
